import { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { useVehicle } from '@repo/domain-service';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

export default function VehicleExistsGuard() {
  const { id } = useParams<{ id: string }>();
  const { vehicle, loadingVehicle } = useVehicle(id!);
  const navigate = useNavigate();

  useEffect(() => {
    if (!id || (!loadingVehicle && !vehicle)) {
      navigate(ROUTE_PATHS[RouteName.ACCOUNT_VEHICLES], { replace: true });
    }
  }, [id, loadingVehicle, vehicle, navigate]);

  if (!vehicle) {
    return null;
  }

  return <Outlet context={vehicle} />;
}
